"use strict";

var focusHelper = require("base/components/focus");

// ✅ FUNÇÕES PARA LOCALSTORAGE
function getConsentFromStorage() {
    return localStorage.getItem("user_consent");
}

function setConsentInStorage(value) {
    localStorage.setItem("user_consent", value);
}

function shouldShowModal() {
    // ✅ Verificar localStorage primeiro
    var persistentConsent = getConsentFromStorage();
    if (persistentConsent) {
        return false; // Já consentiu persistentemente
    }

    // ✅ Depois verificar session (via classe CSS)
    var hasSessionConsent = $(".consented").length > 0;
    return !hasSessionConsent;
}

/**
 * Renders a modal window that will track the users consenting to accepting site tracking policy
 */
function showConsentModal() {
    var trackingConsentData = $(".tracking-consent");
    if (!trackingConsentData.data("caonline") || window.location.href.indexOf("/cart") != -1 || window.location.href.indexOf("/Checkout") != -1) {
        return;
    }

    var urlContent = trackingConsentData.data("url");
    var urlAccept = trackingConsentData.data("accept");
    var urlReject = trackingConsentData.data("reject");
    var textYes = trackingConsentData.data("accepttext");
    var textNo = trackingConsentData.data("rejecttext");
    var textHeader = trackingConsentData.data("heading");
    var tokenName = trackingConsentData.data("tokenname");
    var token = trackingConsentData.data("token");

    var htmlString = `
        <div id="consent-banner" class="cookie-banner d-flex justify-content-center align-items-center">
            <span class="cookie-text text-center"></span>
                <button class="btn btn-light font-weight-bold mx-2 btn-accept"
                    data-url="${urlAccept}" data-action="accept">
                ${textYes}
            </button>

            <button class="btn-close btn-reject" aria-label="Close"
                    data-url="${urlReject}" data-action="close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>`;
    $.spinner().start();


    $.ajax({
        url: urlContent,
        type: "get",
        dataType: "html",
        success: function (response) {
            $.spinner().stop();
            $("body").append(htmlString);
            $(".cookie-text", "#consent-banner").html(response);

            $("#consent-banner button").click(function (e) {
                e.preventDefault();
                var url = $(this).data("url");
                var action = $(this).data("action");
                if (action == "close") {
                    $("#consent-banner").remove();
                    return;
                }
                var data = {};
                data[tokenName] = token;
                $.ajax({
                    url: url,
                    type: "post",
                    data: data,
                    dataType: "json",
                    success: function (response) {
                        // Only hide modal if the operation is successful - don't want to give a false impression
                        if (response.success) {
                            // ✅ SALVAR NO LOCALSTORAGE (PERSISTENTE)
                            if (action === "accept") {
                                setConsentInStorage("true");
                            } else {
                                setConsentInStorage("false");
                            }

                            $("#consent-banner").remove();
                        }
                        $.spinner().stop();
                    },
                    error: function (err) {
                        $.spinner().stop();
                        // Expected error response is for CSRF failure, which will include a redirect to CSRF-Fail
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        }
                    }
                });
            });

        },
        error: function () {
            $.spinner().stop();
            $("#consent-banner").remove();
        }
    });

}

module.exports = function () {
    // if ($(".consented").length === 0 && $(".tracking-consent").hasClass("api-true")) {
    //     console.log($(".consented").length)
    //     console.log($(".tracking-consent").hasClass("api-true"))

    //     console.log('show Modal')
    //     showConsentModal();
    // }else{
    //     console.log('no show Modal')
    //     console.log($(".consented").length)
    //     console.log($(".tracking-consent").hasClass("api-true"))
    //     $.spinner().stop();
    // }

    // ________________________________________________
    // console.log("=== CONSENT CHECK ===");
    // console.log("LocalStorage consent:", getConsentFromStorage());
    // console.log("Session consent (CSS class):", $(".consented").length > 0);

    // ✅ VERIFICAR LOCALSTORAGE PRIMEIRO
    if (shouldShowModal() && $(".tracking-consent").hasClass("api-true")) {
        console.log("Showing modal - no persistent consent found");
        showConsentModal();
    } else {
        console.log("Not showing modal - persistent consent exists");
        $.spinner().stop();
    }

    var localStorageConsent = getConsentFromStorage();

    // ✅ CONDICIONAL PARA EVITAR LOOP INFINITO
    if (localStorageConsent) {
        var url = $(".tracking-consent").attr("data-setConsent");
        // Fazer chamada AJAX para o endpoint de sincronização
        $.ajax({
            url: url,
            type: "GET",
            data: {
                tracking: localStorageConsent
            },
            dataType: "json",
            done: function (response) {
                console.log("Session synchronized with persistent consent.");
            }
        });
    } else {
        $.spinner().stop();
    }

    if ($(".tracking-consent").hasClass("api-true")) {
        $(".tracking-consent").click(function () {
            console.log("show Modal 2");
            showConsentModal();
        });
    }

    $("body").on("shown.bs.modal", "#consent-tracking", function () {
        $("#consent-tracking").siblings().attr("aria-hidden", "true");
        $("#consent-tracking .affirm").focus();
        $.spinner().stop();
    });

    $("body").on("hidden.bs.modal", "#consent-banner", function () {
        $("#consent-banner").siblings().attr("aria-hidden", "false");
    });

    $("body").on("keydown", "#consent-banner", function (e) {
        var focusParams = {
            event: e,
            containerSelector: "#consent-banner",
            firstElementSelector: ".affirm",
            lastElementSelector: ".decline",
            nextToLastElementSelector: ".affirm"
        };
        focusHelper.setTabNextFocus(focusParams);
    });
};
